<div [fxLayout]="layout" fxLayoutGap="10px" fxLayoutAlign="end start">
	<div fxLayout="column" fxLayoutGap="10px" fxFlex="0 1 0%">
		<mat-form-field fxFlex="0 1 0%">
		<mat-label>Label type</mat-label>
		<mat-select [(value)]="labelService.currentLabelType">
			<mat-option *ngFor="let ltemp of labelTemplates" [value]="ltemp.name">{{ltemp.name}}</mat-option>
		</mat-select>
		</mat-form-field>
		<button fxFlex="0 1 0%" mat-raised-button color="primary" [disabled]="loading" (click)="printLabel()">Print</button>
	</div>

	<div id="label-preview" fxFlex [innerHTML]="generatePreview() | safeHtml">
		<!-- <ng-container [ngTemplateOutlet]="label.type === '34x100_34x24' ? label_34x100_34x24 :
									label.type === '25x70_25x17' ? label_25x70_25x17 :
									label_25x17"></ng-container> -->
	</div>
	
</div>


<!-- <ng-template #label_25x70_25x17>
	<svg version="1.1" id="Ebene_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	width="100%" height="100%" viewBox="0 0 73.7 201.26" enable-background="new 0 0 73.7 201.26" xml:space="preserve">
		<path fill="#FFFFFF" stroke="#000000" stroke-miterlimit="10" d="M72.5,193.831c0,3.131-2.538,5.669-5.669,5.669H7.169
		c-3.131,0-5.669-2.538-5.669-5.669V7.169C1.5,4.038,4.038,1.5,7.169,1.5h59.662c3.131,0,5.669,2.538,5.669,5.669V193.831z"/>
		<line fill="none" stroke="#000000" stroke-miterlimit="10" x1="1" y1="150.5" x2="72" y2="150.5"/>
		<text transform="matrix(1 0 0 1 26.188 161.3301)"><tspan x="0" y="0" font-family="'Arial'" font-size="9">MBG</tspan><tspan x="0" y="10.8" font-family="'Arial'" font-size="9">Espelkamp</tspan></text>
		<text transform="matrix(1 0 0 1 4.0464 181.9717)" font-family="'Arial'" font-size="7">{{label.id.toString().padStart(5, '0')}}</text>
		<text transform="matrix(1 0 0 1 30 181.9717)" font-family="'Arial'" font-size="7">{{label.place}}</text>
		<text transform="matrix(1 0 0 1 45 181.9717)" font-family="'Arial'" font-size="7">{{formatDate()}}</text>
		<text transform="matrix(1 0 0 1 3.7837 193.7637)" font-family="'Arial'" font-size="9">{{label.info}}</text>
	</svg>
	<qrcode [qrdata]="label.id.toString()" width="40" errorCorrectionLevel="L" elementType="canvas" margin="0" scale="1" style="position: relative;top: -95px;left: 8px;"></qrcode>
</ng-template>




<ng-template #label_34x100_34x24>
	<svg version="1.1" id="Ebene_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 width="100%" height="100%" viewBox="0 0 99.213 286.299" enable-background="new 0 0 99.213 286.299"
	 xml:space="preserve">
		<path fill="#FFFFFF" stroke="#000000" stroke-miterlimit="10" d="M97.856,276.533c0,4.482-3.445,8.116-7.695,8.116H9.552
			c-4.25,0-7.695-3.634-7.695-8.116V9.766c0-4.482,3.445-8.116,7.695-8.116h80.609c4.25,0,7.695,3.634,7.695,8.116V276.533z"/>
		<line fill="none" stroke="#000000" stroke-miterlimit="10" x1="1.356" y1="216.649" x2="97.356" y2="216.649"/>
		<text transform="matrix(1 0 0 1 35.2114 230.0186)"><tspan x="0" y="0" font-family="'Arial'" font-size="12">MBG</tspan><tspan x="0" y="14.4" font-family="'Arial'" font-size="12">Espelkamp</tspan></text>
		<text transform="matrix(1 0 0 1 6.2427 256.4551)" font-family="'Arial'" font-size="9">{{label.id.toString().padStart(5, '0')}}</text>
		<text transform="matrix(1 0 0 1 41.2119 256.4551)" font-family="'Arial'" font-size="9">{{label.place}}</text>
		<text transform="matrix(1 0 0 1 60.5459 256.4551)" font-family="'Arial'" font-size="9">{{formatDate()}}</text>
		<text transform="matrix(1 0 0 1 6.2427 267.2471)" font-family="'Arial'" font-size="9">{{label.info}}</text>
		<text transform="matrix(1 0 0 1 6.2427 278.2471)" font-family="'Arial'" font-size="9">{{label.info}}</text>
	</svg>
	<qrcode [qrdata]="label.id.toString()" width="42" errorCorrectionLevel="L" elementType="canvas" margin="0" scale="1" style="position: relative;top: -100px;left: 8px;"></qrcode>
</ng-template>




<ng-template #label_25x17>
	<svg version="1.1" id="Ebene_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
		width="100%" height="100%" viewBox="0 0 73.701 51.023" enable-background="new 0 0 73.701 51.023" xml:space="preserve">
		<path fill="#FFFFFF" stroke="#000000" stroke-miterlimit="10" d="M72.5,6.933c0-3.131-2.538-5.669-5.669-5.669H7.169
			C4.039,1.264,1.5,3.802,1.5,6.933v37.662c0,3.131,2.538,5.669,5.669,5.669h59.662c3.131,0,5.669-2.538,5.669-5.669V6.933z"/>
		<text transform="matrix(1 0 0 1 26.2881 12.7773)"><tspan x="0" y="0" font-family="'Arial'" font-size="9">MBG</tspan><tspan x="0" y="10.8" font-family="'Arial'" font-size="9">Espelkamp</tspan></text>
		<text transform="matrix(1 0 0 1 4.1465 33.4189)" font-family="'Arial'" font-size="7">{{label.id.toString().padStart(5, '0')}}</text>
		<text transform="matrix(1 0 0 1 29.6631 33.4189)" font-family="'Arial'" font-size="7">{{label.place}}</text>
		<text transform="matrix(1 0 0 1 45.1626 33.4189)" font-family="'Arial'" font-size="7">{{formatDate()}}</text>
		<text transform="matrix(1 0 0 1 3.8838 45.2109)" font-family="'Arial'" font-size="9">{{label.info}}</text>
	</svg>
	<qrcode [qrdata]="label.id.toString()" width="40" errorCorrectionLevel="L" elementType="canvas" margin="0" scale="1" style="position: relative;top: -93px;left: 8px;"></qrcode>
</ng-template> -->

